import { render, staticRenderFns } from "./allinpay_account_edit.vue?vue&type=template&id=e5199bb2&scoped=true"
import script from "./allinpay_account_edit.vue?vue&type=script&lang=js"
export * from "./allinpay_account_edit.vue?vue&type=script&lang=js"
import style0 from "./allinpay_account_edit.vue?vue&type=style&index=0&id=e5199bb2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5199bb2",
  null
  
)

export default component.exports